<template>
  <div>
    <Collapse v-model="value2" simple style="border: 0">
      <Panel name="5" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="入职申请" />
        <Form
          slot="content"
          disabled
          :label-width="140"
          label-position="left"
          style="margin: 30px 30px 0 30px"
          :model="formItem"
          ref="formItem"
          :rules="rules"
        >
          <Row>
            <Col :xs="24" :sm="24" :md="24" :lg="12" :xl="7">
              <FormItem label="员工姓名">
                <Input v-model="formItem.userName">
                  <Button
                    type="primary"
                    slot="append"
                    icon="ios-search"
                  ></Button>
                </Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col :xs="24" :sm="24" :md="24" :lg="12" :xl="7">
              <FormItem label="应聘职位" prop="candidatePosition">
                <Input v-model="formItem.candidatePosition" />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="1" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="个人信息" />
        <Form
          disabled
          :label-width="140"
          slot="content"
          label-position="left"
          style="margin: 30px 30px 0 30px"
        >
          <Row span="24" style="margin-bottom:30px">
            <Col :xxl="3" :xl="5" :lg="7" :md="9" :sm="11" :xs="12">
              <Button type="primary">个人信息确认</Button>
            </Col>
            <Col :xxl="3" :xl="5" :lg="7" :md="9" :sm="11" :xs="12">
              <Button type="primary">查看应聘申请表</Button>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="中文姓名：">
                <Input disabled v-model="formItem.userName" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="性别：">
                <Select
                  disabled
                  v-model="formItem.gender"
                  :clearable="true"
                  placeholder=""
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in genderList"
                    :key="i"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="民族：">
                <Select
                  v-model="formItem.ethnic"
                  :clearable="true"
                  placeholder=""
                  disabled
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in nationList"
                    :key="i"
                    >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="证件号码：">
                <Input disabled v-model="formItem.nationalIdNumber" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="国籍：">
                <Select
                  v-model="formItem.nationality"
                  :clearable="true"
                  placeholder=""
                  disabled
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in nationalityList"
                    :key="i"
                    >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="护照号码：">
                <Input disabled v-model="formItem.passportnumber" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="姓（拼音）：">
                <Input disabled v-model="formItem.lastNamePinyin" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="名（拼音）：">
                <Input disabled v-model="formItem.firstNamePinyin" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="英文名：">
                <Input disabled v-model="formItem.userEname" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="年龄：">
                <Input disabled v-model="formItem.age" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="手机：">
                <Input disabled v-model="formItem.mobilePersonal" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="个人电子邮箱：">
                <Input disabled v-model="formItem.mail" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="婚姻状况：">
                <Input disabled v-model="formItem.maritalStatus" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="常住地址：">
                <Input disabled v-model="formItem.homeAddress" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="户籍地址：">
                <Input disabled v-model="formItem.legalAddress" />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="2" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="入职信息" />
        <Form
          disabled
          :label-width="140"
          slot="content"
          label-position="left"
          style="margin: 30px 30px 0 30px"
          :model="formItem"
          ref="formItem"
          :rules="rules"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="雇佣日：" prop="latestHiringDate">
                <Date-picker
                  v-model="formItem.latestHiringDate"
                  type="date"
                  placeholder=""
                  style="width: 100%"
                ></Date-picker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="有效雇佣日：">
                <Date-picker
                  v-model="formItem.serviceStartDate"
                  type="date"
                  placeholder=""
                  style="width: 100%"
                >
                </Date-picker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="社会工龄起始日：">
                <Date-picker
                  type="date"
                  placeholder=""
                  v-model="formItem.socialWorkStartDate"
                  style="width: 100%"
                >
                </Date-picker>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="试用期结束日：">
                <Date-picker
                  type="date"
                  placeholder=""
                  v-model="formItem.probationEndDate"
                  style="width: 100%"
                >
                </Date-picker>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="3" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="合同信息" />
        <Form
          disabled
          :label-width="140"
          slot="content"
          label-position="left"
          style="margin: 30px 30px 0 30px"
          :model="formItem"
          ref="formItem"
          :rules="rules"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="合同开始日期：" prop="contractStartDate">
                <Date-picker
                  v-model="formItem.contractStartDate"
                  type="date"
                  placeholder=""
                  style="width: 100%"
                >
                </Date-picker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="合同结束日期：">
                <Date-picker
                  v-model="formItem.contractEndDate"
                  type="date"
                  placeholder=""
                  style="width: 100%"
                >
                </Date-picker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="合同年限">
                <Input v-model="formItem.laborContractPeriod" />
                <!-- <Row>              
                        <Col span="5" ><Input /></Col>年
                        <Col span="5" offset="2"><Input /></Col>月
                        <Col span="5" offset="2"><Input /></Col>日    
                    </Row> -->
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="合同类型：">
                <Select
                  v-model="formItem.contractType"
                  :clearable="true"
                  placeholder=""
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in contractTypeList"
                    :key="i"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="4" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="工作服信息" />
        <Form
          disabled
          :label-width="140"
          slot="content"
          label-position="left"
          style="margin: 30px 30px 0 30px"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="身高：">
                <Input v-model="formItem.height" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="体重：">
                <Input v-model="formItem.weight"></Input>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="衣服尺码：">
                <Input v-model="formItem.clothesSize" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="裤子尺码：">
                <Input v-model="formItem.trousersSize" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="鞋子尺码：">
                <Input v-model="formItem.shoesSize" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="" :label-width="0">
                <Button type="primary">尺码参照表</Button>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="5" hide-arrow style="margin-bottom: 20px; border: 0">
        <!-- 审批历史 -->
        <FormTitle :titleText="$t('审批历史')" />
        <Table
          border
          :columns="columns3"
          :data="data3"
          slot="content"
          style="margin:30px"
        >
        </Table>
      </Panel>
    </Collapse>
    <div class="btnRight">
      <Button
        type="primary"
        class="applyBtnRight"
        @click="submit"
        v-if="!getQueryVariable('isProcessList') && !isHistory"
        >同意</Button
      >
      <Button
        type="primary"
        class="applyBtnRight"
        @click="reject"
        v-if="!getQueryVariable('isProcessList') && !isHistory"
        >驳回</Button
      >
      <Button type="primary" class="applyBtnRight" @click="returnPage"
        >返回</Button
      >
    </div>
    <Modal
      v-model="showdataAgree"
      :title="$t('请填写审批意见')"
      width="500"
      :mask-closable="false"
    >
      <Input v-model="rejectMessage.message" type="textarea" :rows="5"></Input>
      <div slot="footer">
        <Button @click="yess1">{{ $t("确定") }}</Button>
        <Button @click="cancell1">{{ $t("取消") }}</Button>
      </div>
    </Modal>
    <Modal
      v-model="showdataRejected"
      :title="$t('请填写驳回意见')"
      width="500"
      :mask-closable="false"
    >
      <Form :rules="ruleValidate" :model="rejectMessage" ref="rejectMessage">
        <FormItem prop="message">
          <Input
            v-model="rejectMessage.message"
            type="textarea"
            :rows="5"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="yess2">{{ $t("确定") }}</Button>
        <Button @click="cancell2">{{ $t("取消") }}</Button>
      </div>
    </Modal>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    return {
      rules: {
        candidatePosition: [{ required: true, message: "请填写应聘职位！" }],
        latestHiringDate: [
          { required: true, type: "date", message: "请填写雇佣日！" }
        ],
        contractStartDate: [
          { required: true, type: "date", message: "请填写合同开始日期！" }
        ],
        contractType: [
          { required: true, trigger: "change", message: "请填写合同类型！" }
        ]
      },
      ruleValidate: {
        message: [{ required: true, message: this.$t("请填写驳回意见") + "！" }]
      },
      date: new DateUtil(),
      formItem: {},
      searchList: {},
      value2: [1, 2, 3, 4, 5],
      contractTypeList: [],
      nationList: [],
      genderList: [],
      nationalityList: [],
      JobApplicationForm: false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 1,
      loading: false,
      showdataAgree: false, //审批意见
      showdataRejected: false, //驳回意见
      rejectMessage: {},
      columns3: [
        {
          title: this.$t("审批流名称"),
          key: "stepName",
          align: "center",
          width: "280"
        },
        {
          title: this.$t("实际审批者"),
          key: "userName",
          align: "center",
          width: "280"
        },
        {
          title: this.$t("审批时间"),
          key: "time",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
            );
          }
        },
        {
          title: this.$t("审批状态"),
          key: "status",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              params.row.status == "0"
                ? "通过"
                : params.row.status == "1"
                ? "驳回"
                : ""
            );
          }
        },
        {
          title: this.$t("审批意见"),
          key: "message",
          align: "center",
          width: "435"
        }
      ],
      data3: [],
      isHistory: false
    };
  },
  created() {
    this.getData();
    this.getSelectLabel();
    if (this.getQueryVariable("history")) {
      this.isHistory = true;
    }
  },
  methods: {
    getSelectLabel() {
      axios
        .post("ApplyOnboarding/selectApplyOnboardingComboBox", {})
        .then(res => {
          if (res) {
            this.contractTypeList = res.CONTRACTTYPE;
            this.nationList = res.ETHNIC;
            this.genderList = res.GENDER;
            this.nationalityList = res.PPISSUECOUNTRY;
          }
        });
    },
    getData() {
      let obj = { instanceId: this.getQueryVariable("instanceId") };
      axios.post("ApplyOnboarding/selectApplyOnboarding", obj).then(res => {
        if (res) {
          this.formItem = res.onboarding;
          this.data3 = res.logMap;
        }
      });
    },
    returnPage() {
      if (this.getQueryVariable("isProcessList") == "true") {
        this.$router.push(
          "/3643BE389560158D15632DBE8934C23596BCE18CD6B2387A/A3FFBEBFDB713E27"
        );
      } else if (this.isHistory) {
        this.$router.push(
          "/3911E071298B94E27537586515457CF2BA610C6A6F738319/A3FFBEBFDB713E27"
        );
      } else {
        this.$router.push("/27B8ABB6F63EFBBE75D07D383A598492/A3FFBEBFDB713E27");
      }
    },
    submit() {
      this.showdataAgree = true;
    },
    reject() {
      this.showdataRejected = true;
    },
    yess1() {
      this.showdataAgree = false;
      let arr1 = [
        {
          objData1: { approval_result: "0" },
          stringData1: this.getQueryVariable("taskId"),
          stringData2: this.rejectMessage.message,
          type: "B17"
        }
      ];
      this.loading = true;
      axios.post("/process/execute", arr1).then(res => {
        this.loading = false;
        if (res) {
          this.$Message.info(this.$t("Approval_Completed"));
          this.$router.push(
            "/27B8ABB6F63EFBBEF7BD77EC1FE93AE8D5AC2804BF5BD5A1/A3FFBEBFDB713E27"
          );
        }
      });
    },
    cancell1() {
      this.showdataAgree = false;
    },
    cancell2() {
      this.showdataRejected = false;
    },
    yess2() {
      this.$refs["rejectMessage"].validate(valid => {
        if (valid) {
          let arr = [
            {
              objData1: { approval_result: "1" },
              stringData1: this.getQueryVariable("taskId"),
              stringData2: this.rejectMessage.message,
              type: "B17"
            }
          ];
          this.showdataRejected = false;
          this.loading = true;
          axios.post("/process/execute", arr).then(res => {
            this.loading = false;
            if (res) {
              this.$Message.info(this.$t("审批驳回成功"));
              this.$router.push(
                "/27B8ABB6F63EFBBEF7BD77EC1FE93AE8D5AC2804BF5BD5A1/A3FFBEBFDB713E27"
              );
            }
          });
        }
      });
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/process/Apply/OnboardingApproval.vue